<template>
  <div class="popup_index_warp">
    <div class="address_index-warp">
      <div class="title">
        <div class="strong">拒绝原因</div>
        <div class="address_info_item">
            <div class="address_info_info">
              <h5 class="h5">存疑原因</h5>
              <p class="p2">{{rejectInfo.branchRejectReason}}</p>
            </div>
        </div>
        <div class="address_info_item2">
          <van-row v-if="rejectInfo.imageInfoListBranch && rejectInfo.imageInfoListBranch.length > 0">
            <h5 class="h5">图片凭证</h5>
            <van-col span="24">
              <van-grid :border="false" :column-num="4">
                <van-grid-item v-for="(item,index) in rejectInfo.imageInfoListBranch" :key="index">
                  <van-image
                    height="70"
                    width="70"
                    :src="item.imageUrl"
                    @click="showMaxImgFun([item.imageUrl])"
                  />
                </van-grid-item> 
              </van-grid>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="adderss_index-btn" v-show="role != 'bee'">
        <van-button class="bt be" round @click="submitOk">知道了</van-button>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  data(){
    return{
      addressDetails:{},
      showD:true
    }
  },
  props:{
    role:{
      default:'bee'
    },
    value:{
      default:false
    },
    rejectInfo:{
      default:function(){return{}},
      type:Object
    }
  },
  methods:{
    submitOk(item){
      this.$emit('closeModal', false)
    },
    showMaxImgFun(img){
      this.$emit('callbackShowMaxImgFun', img)
    }
  },
}
</script>
<style lang="less" scoped>
  .popup_index_warp{
    .address_index-warp{
      text-align: left;
      padding: 20px;
      .strong{
        font-size: 32px;
        color: #333;
        text-align: center;
        font-weight: bold;
      }
      .address_info_item{
        padding: 30px;
        margin-top: 30px; 
        align-items: center;
        background-color: #f7f7f7;
        border-radius: 10px;
        margin-bottom: 20px;
        .address_info_info{
          text-align: left;
          
          .h5{
            font-size: 26px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 10px;
          }
          .p2{
            font-size: 24px;
            color: #999;
          }
        }
      }
      .address_info_item2{
        .h5{
          font-size: 26px;
          font-weight: 500;
          color: #333333;
        }

      }
      .adderss_index-btn{
        padding-top: 100px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .bt{
          width: 440px;
          background: var(--epButtonColor);
          color: var(--epTextColor);
        }
        .bt.bd{
          color: #999999;
          border-color: #999999;
        }
        .bt.be {
          color: #333 !important;
        }
      }
      .dese{
        color: #F8A651;
        font-size: 26px;
      }
    }
  }
</style>